// src/legal/legalRequired.ts
//
// The server refuses a user whose legal acceptance has run out with the reason
// `legal_required`: a callable throws it as its message, the API proxy answers
// 403 with it. The places such errors pass through report them here; LegalGate
// listens and re-reads the user record, so the dialog appears.
//
// No imports on purpose: this is part of the entry bundle and is pulled in by
// the API client and the auth provider.

const REASON = 'legal_required';

type Listener = () => void;
const listeners = new Set<Listener>();

export function isLegalRequiredError(error: unknown): boolean {
    if (!error || typeof error !== 'object') return false;
    const { message, status } = error as {
        message?: unknown;
        status?: unknown;
    };
    if (typeof message !== 'string') return false;
    if (message === REASON) return true;
    return status === 403 && message.includes(REASON);
}

/** Subscribe to refusals. Returns the unsubscribe function. */
export function onLegalRequired(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

/** Reports the error if it is a `legal_required` refusal. Returns whether it was. */
export function reportIfLegalRequired(error: unknown): boolean {
    if (!isLegalRequiredError(error)) return false;
    for (const listener of [...listeners]) {
        try {
            listener();
        } catch (listenerError) {
            // The caller is in the middle of handling its own error.
            console.error('legal_required listener failed:', listenerError);
        }
    }
    return true;
}
